import { AsyncSelect } from '@/components';
import { useEffect, useState } from 'react';
import { useHomeLookupSource } from '../Homes.Common';
import { useTranslation } from 'react-i18next';

interface Props {
  communityId: string;
  projectId?: string;
  className?: string;
  onSelected: (id: string | undefined) => any;
  selectedId: string | undefined;
  showResidentNames?: boolean;
}

export const PROJECT_HOME_STORAGE_KEY = 'selectedProjectHomeId';

export function useProjectHomeSelectedState(
  initialId?: string,
): Pick<Props, 'onSelected' | 'selectedId'> {
  const [selectedId, setSelectedId] = useState<string | undefined>(() => {
    const stored = sessionStorage.getItem(PROJECT_HOME_STORAGE_KEY);
    return stored ?? initialId;
  });

  useEffect(() => {
    if (selectedId == null) {
      sessionStorage.removeItem(PROJECT_HOME_STORAGE_KEY);
    } else {
      sessionStorage.setItem(PROJECT_HOME_STORAGE_KEY, selectedId);
    }
  }, [selectedId]);

  return { selectedId, onSelected: setSelectedId };
}

export function SearchProjectHomeInput(props: Props) {
  const {
    communityId,
    projectId,
    className,
    onSelected,
    selectedId,
    showResidentNames,
  } = props;
  const dataSource = useHomeLookupSource(
    communityId,
    projectId,
    showResidentNames,
  );
  const { t } = useTranslation();

  return (
    <AsyncSelect
      className={className}
      value={selectedId}
      onChange={onSelected}
      dataSource={dataSource}
      placeholder={t('developScope.selectHome')}
      preload
      placement="bottomLeft"
      onSearchLoad={(options) => {
        !options.some((x) => x.value === selectedId) && onSelected(undefined);
      }}
    />
  );
}
